import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { GenericWorksheet } from '../types/worksheet';
import { isMock } from '../utilities/is-mock';
import { sort } from '../features/trial-balance/sort';

type GetOtherSchedulesResponse = {
    otherSchedules: GenericWorksheet[];
    totalItems: number;
};

type UseOtherSchedulesConfig = {
    filterQuery?: string;
    searchQuery?: string;
    sortQuery?: string;
    limit?: number;
    page: number;
    tab?: string;
    enabled?: boolean;
};

async function getOtherSchedules(workpaperId: string, params: UseOtherSchedulesConfig): Promise<GetOtherSchedulesResponse> {
    const { data } = await api.get(`/workpapers/${workpaperId}/other-schedules?${params.filterQuery}&${params.sortQuery}`, {
        params: {
            limit: params.limit,
            page: params.page,
            status: params.tab,
            search: params.searchQuery,
            searchFilters: params.tab ? 'status' : undefined,
        },
    });
    return data;
}

export function useOtherSchedules(
    { limit, page, tab, filterQuery, searchQuery, sortQuery, enabled = true }: UseOtherSchedulesConfig,
    overrideWorkpaperId?: string
): UseQueryResult<GetOtherSchedulesResponse, unknown> {
    const { id: contextWorkpaperId } = useWorkpaperContext();
    const workpaperId = overrideWorkpaperId || contextWorkpaperId;

    return useQuery(
        ['other-schedules', workpaperId, filterQuery, sortQuery, searchQuery, page, limit, tab],
        () =>
            getOtherSchedules(workpaperId, {
                limit,
                page,
                tab,
                filterQuery,
                searchQuery,
                sortQuery,
            }),
        {
            enabled: enabled && filterQuery !== undefined && searchQuery !== undefined && sortQuery !== undefined,
            keepPreviousData: true,
        }
    );
}
